// extracted by mini-css-extract-plugin
module.exports = {"item":"NewsList_item__aGyiH","container":"NewsList_container__XI6nL","item_title":"NewsList_item_title__1TAur","item_date":"NewsList_item_date__7eQ90"};